// mixin 是很脆弱的，使用时有很多限制，最基本最重要的是：需要统一mixin内外的数据和选项
// mixin内外: 内，mixin文件内部；外，使用mixin的文件
// 数据，data内定义的数据
// 选项，即vue的选项，data methods computed watch 之类

import { axiosApi } from '@/common/js/api'

import * as Select from '@/common/js/select-data-api/index.js'

// 行业 ~~~
export const getplatlists = {
  data() {
    return {
      platlists: [],
      platCode: '' // form中platCode字段；
    }
  },
  created() {
    this.getplatlists()
  },
  methods: {
    async getplatlists() {
      let { data, err } = await axiosApi(Select.getprofession_api)
      this.platlists = data.data.data
    }
  }
}

// 商家 ~~~
export const getptnlists = {
  data() {
    return {
      ptnlists: [],
      ptnListLoading: false
    }
  },
  created() {
    // this.getptnlists()
  },
  methods: {
    async getptnlists() {
      this.ptnListLoading = true
      let { data, err } = await axiosApi(
        Select.getptnlists_api,
        {},
        {
          profCode: this.form.profession
        }
      )
      this.ptnListLoading = false
      if (data && data.data.meta.status === 200) {
        this.ptnlists = data.data.data
      } else {
        this.ptnlists = []
      }
    }
  },
  watch: {
    'form.profession': {
      handler: function(newVal, oldVal) {
        // console.log('this.is.getshoplists watch')
        if (this.form.profession) this.getptnlists()
        this.form.business = ''
        this.ptnlists = []
      },
      immediate: true
    }
  }
}

// 店铺  获取商家下的店铺 ~~~
export const getshoplists = {
  data() {
    return {
      shoplists: [],
      shopListLoading: false
    }
  },
  created() {},
  methods: {
    async getshoplists() {
      this.shopListLoading = true
      let { data, err } = await axiosApi(
        Select.getshoplists_api,
        {},
        { ptnCode: this.form.business }
      )
      this.shopListLoading = false
      // this.shoplists = data.data.data
      if (data && data.data.meta.status === 200) {
        this.shoplists = data.data.data
      } else {
        this.shoplists = []
      }
    }
  },
  watch: {
    // 监听 商家变化 获取该商家下的店铺，需要统一 ptnCode 为商家,并且将ptnCode 挂载在this.form上
    'form.business': {
      handler: function(newVal, oldVal) {
        // console.log('this.is.getshoplists watch')
        if (this.form.business) this.getshoplists()
        this.form.store = ''
        this.shoplists = []
      },
      immediate: true
    }
  }
}

// 订单状态 ~~~
export const gettradestatus = {
  data() {
    return {
      tradestatus: []
    }
  },
  created() {
    this.gettradestatus()
  },
  methods: {
    async gettradestatus() {
      let { data, err } = await axiosApi(Select.gettradestatus_api)
      if (data && data.data.meta.status === 200) {
        this.tradestatus = data.data.data
      } else {
        this.tradestatus = []
      }
    }
  }
}

// 来源平台接口地址 ~~~
export const gettradefrom = {
  data() {
    return {
      tradefrom: []
    }
  },
  created() {
    this.gettradefrom()
  },
  methods: {
    async gettradefrom() {
      let { data, err } = await axiosApi(Select.gettradefrom_api)
      if (data && data.data.meta.status === 200) {
        this.tradefrom = data.data.data
      } else {
        this.tradefrom = []
      }
    }
  }
}

// 卖家网 搜索项里的行业 和其他页面中的行业是不同的  两个接口
export const getmaijiaProfession = {
  data() {
    return {
      maijiaProfession: []
    }
  },
  created() {
    this.getmaijiaProfession()
  },
  methods: {
    async getmaijiaProfession() {
      let { data, err } = await axiosApi(Select.getmaijiaProfession_api)
      if (data && data.data.meta.status === 200) {
        this.maijiaProfession = data.data.data
      } else {
        this.maijiaProfession = []
      }
    }
  }
}

// 品牌
export const getbrdlists = {
  data() {
    return {
      brdlists: []
    }
  },
  created() {
    this.getbrdlists()
  },
  methods: {
    async getbrdlists() {
      let { data, err } = await axiosApi(Select.getbrdlists_api)
      this.brdlists = data.data.data
    }
  }
}

// 订单类型
export const getordtype = {
  data() {
    return {
      ordtype: []
    }
  },
  created() {
    this.getordtype()
  },
  methods: {
    async getordtype() {
      let { data, err } = await axiosApi(Select.getordtype_api)
      this.ordtype = data.data.data
    }
  }
}

// 订单标记
export const getordsign = {
  data() {
    return {
      ordsign: []
    }
  },
  created() {
    this.getordsign()
  },
  methods: {
    async getordsign() {
      let { data, err } = await axiosApi(Select.getordsign_api)
      this.ordsign = data.data.data
    }
  }
}

// 发货页面 发货单状态
export const getoutstkflag = {
  data() {
    return {
      outstkflag: []
    }
  },
  created() {
    this.getoutstkflag()
  },
  methods: {
    async getoutstkflag() {
      let { data, err } = await axiosApi(Select.getoutstkflag_api)
      if (data) {
        this.outstkflag = data.data.data
      }
    }
  }
}

// 订单状态
export const getplatordstatus = {
  data() {
    return {
      platordstatus: [],
      platCode: ''
    }
  },
  methods: {
    async getplatordstatus(platCode) {
      let { data, err } = await axiosApi(
        Select.getplatordstatus_api,
        {},
        { platCode: platCode }
      )
      if (data) {
        this.platordstatus = data.data.data
      }
    },
    platordstatusFocus() {
      if (!this.form.platCode) {
        this.$notify({
          title: '提示',
          message: '请先选择平台'
        })
      }
    }
  },
  watch: {
    platCode: function(newVal, oldVal) {
      this.form.platCode = newVal

      if (newVal) {
        console.log('newVal', newVal)
        this.getplatordstatus(newVal)
      }
    }
  }
}

// 仓库
export const getstrlists = {
  data() {
    return {
      strlists: []
    }
  },
  created() {
    this.getstrlists()
  },
  methods: {
    async getstrlists() {
      let { data, err } = await axiosApi(Select.getstrlists_api)
      this.strlists = data.data.data
    }
  }
}

// 库存状态
export const getinvstatuslists = {
  data() {
    return {
      invstatuslists: []
    }
  },
  created() {
    this.getinvstatuslists()
  },
  methods: {
    async getinvstatuslists() {
      let { data, err } = await axiosApi(Select.getinvstatuslists_api)
      this.invstatuslists = data.data.data
    }
  }
}

// 库存下单状态
export const getinvsendstatuslists = {
  data() {
    return {
      invsendstatuslists: []
    }
  },
  created() {
    this.getinvsendstatuslists()
  },
  methods: {
    async getinvsendstatuslists() {
      let { data, err } = await axiosApi(Select.getinvsendstatuslists_api)
      this.invsendstatuslists = data.data.data
    }
  }
}

// 根据商家店铺获取 sku
export const getSkuByPtnShoplists = {
  data() {
    return {
      SkuByPtnShoplists: [],
      skuListLoading: false
    }
  },

  methods: {
    async getSkuByPtnShoplists(param) {
      this.skuListLoading = true
      let { data, err } = await axiosApi(Select.getSkuByPtnShop_api, param)
      this.skuListLoading = false
      this.SkuByPtnShoplists = data.data.data
    }
  }
}

// 根据商家店铺获取 赠品 sku
export const getGiftSkuByPtnShoplists = {
  data() {
    return {
      GiftSkuByPtnShoplists: [],
      GiftSkuListLoading: false
    }
  },
  methods: {
    async getGiftSkuByPtnShoplists(param) {
      this.GiftSkuListLoading = true
      let { data, err } = await axiosApi(Select.getGiftSkuByPtnShop_api, param)
      this.GiftSkuListLoading = false
      this.GiftSkuByPtnShoplists = data.data.data
    }
  }
}

// 根据商家店铺获取   互斥活动
// 赠品管理
// 互斥活动ID下拉项
export const getActEventByPtnShoplists = {
  data() {
    return {
      ActEventList: [],
      ActEventLoading: false
    }
  },

  methods: {
    async getActEventByPtnShoplists(param) {
      this.ActEventLoading = true
      let { data, err } = await axiosApi(Select.getActEventByPtnShop_api, param)
      this.ActEventLoading = false
      console.log(data.data)
      this.ActEventList = data.data.data
    }
  }
}

// 3.0.6.0 获取库存分配方式
export const getStkSetTypeList = {
  data() {
    return {
      stkSetTypeList: []
    }
  },
  created() {
    this.getStkSetTypeList()
  },
  methods: {
    async getStkSetTypeList() {
      let { data, err } = await axiosApi(Select.getStkSetType_api)
      this.stkSetTypeList = data.data.data
    }
  }
}

// 3.0.5.0 获取拆分合并订单规则
// 类型：1拆分，2合并,只允许数字。
export const getmergeruleslist = {
  data() {
    return {
      mergeruleslist: []
    }
  },
  created() {
    this.getmergeruleslist()
  },
  methods: {
    async getmergeruleslist() {
      let { data, err } = await axiosApi(
        Select.getordrules_api,
        {},
        { type: 2 }
      )
      this.mergeruleslist = data.data.data
    }
  }
}

export const getspliteruleslist = {
  data() {
    return {
      spliteruleslist: []
    }
  },
  created() {
    this.getspliteruleslist()
  },
  methods: {
    async getspliteruleslist() {
      let { data, err } = await axiosApi(
        Select.getordrules_api,
        {},
        { type: 1 }
      )
      this.spliteruleslist = data.data.data
    }
  }
}

// 根据商家店铺获取仓库 货主信息
// getownerbyptnshop

export const getownerbyptnshop = {
  data() {
    return {
      warehouseAndOwnerList: [],
      warehouseAndOwnerLoading: false
    }
  },

  methods: {
    async getownerbyptnshop(query) {
      this.warehouseAndOwnerLoading = true
      let { data, err } = await axiosApi(
        Select.getownerbyptnshop_api,
        {},
        query
      )
      this.warehouseAndOwnerList = data.data.data
      this.warehouseAndOwnerLoading = false
    }
  }
}

// 入库状态
export const getinvstockstatuslists = {
  data() {
    return {
      invstockstatuslists: []
    }
  },
  created() {
    this.getinvstockstatuslists()
  },
  methods: {
    async getinvstockstatuslists() {
      let { data, err } = await axiosApi(Select.getinvstockstatuslists_api)
      this.invstockstatuslists = data.data.data
    }
  }
}

// 退款单状态
export const getrefundstatus = {
  data() {
    return {
      refundstatus: []
    }
  },
  created() {
    this.getrefundstatus()
  },
  methods: {
    async getrefundstatus() {
      let { data, err } = await axiosApi(Select.getrefundstatus_api)
      this.refundstatus = data.data.data
    }
  }
}

// 退款原因
export const getrefundreason = {
  data() {
    return {
      refundreason: []
    }
  },
  created() {
    this.getrefundreason()
  },
  methods: {
    async getrefundreason() {
      let { data, err } = await axiosApi(Select.getrefundreason_api)
      this.refundreason = data.data.data
    }
  }
}

// // 卖家网行业 导入弹窗中的下拉
// export const getmaijiawangProfession = {
//   data() {
//     return {
//       mjprofession: []
//     }
//   },
//   created() {
//     this.getmjprofession()
//   },
//   methods: {
//     async getmjprofession() {
//       let { data, err } = await axiosApi(Select.getmaijiawangProfession)
//       this.mjprofession = data.data.data
//     }
//   }
// }



// WEBPACK FOOTER //
// ./src/common/mixins/rfmselect/index.js